import { useExtracted } from "next-intl";
import type { PricingFeature } from "./PricingFeatureList";

export function useMembershipFeatures(): PricingFeature[] {
  const te = useExtracted();

  return [
    {
      key: "layers",
      title: te("Layered strategy construction and tracking"),
      detail: te("Build layered strategies and manage option contracts."),
    },
    {
      key: "model",
      title: te("3D payoff across price and time"),
      detail: te("Volatility surfaces, smile and skew"),
    },
    {
      key: "review",
      title: te("Review and analysis"),
      detail: te("Go deeper with the complete analysis toolkit."),
    },
    {
      key: "notebook",
      title: te("Personal knowledge notebook"),
      detail: te(
        "Capture trading thoughts and review insights, and gradually build your own knowledge system.",
      ),
    },
  ];
}
